export enum SuppressionLogic {
  APPROACHING_ONLY = 'approaching_only',
  APPROACHING_AND_UNKNOWN = 'approaching_and_unknown',
  ALL_DETECTIONS = 'all_detections',
}
